module.exports = __webpack_public_path__ + "static/media/bm.e28367a1.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/bm.svg
// module id = 780
// module chunks = 0